import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiClient } from "@/lib/api";
import { MessageSquare, ArrowRight } from "lucide-react";

export default function ConversationsCard() {
  const [convs, setConvs] = useState(null);

  useEffect(() => {
    apiClient.get("/conversations/me")
      .then(({ data }) => setConvs(data.conversations || []))
      .catch(() => setConvs([]));
  }, []);

  const frDate = (iso) => {
    try {
      const d = new Date(iso);
      return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit" }) + " " +
        d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });
    } catch {
      return "";
    }
  };

  return (
    <div className="mb-8 border-2 border-[#0A0A0B] bg-white" data-testid="conversations-card">
      <div className="border-b-2 border-[#0A0A0B] px-6 py-4 flex items-center gap-2">
        <MessageSquare className="w-5 h-5 text-[#FF4D00]" />
        <div className="display text-2xl">Mes échanges</div>
      </div>
      {convs === null ? (
        <div className="p-6 text-sm text-zinc-500">Chargement…</div>
      ) : convs.length === 0 ? (
        <div className="p-6 text-sm text-zinc-500" data-testid="conversations-empty">
          Aucune conversation pour l'instant — les échanges démarrent dès qu'un devis est déposé sur une mission.
        </div>
      ) : (
        <div className="divide-y-2 divide-zinc-100 max-h-80 overflow-auto">
          {convs.map((c) => (
            <Link
              key={`${c.mission_id}-${c.thread_artisan_id || "x"}`}
              to={`/missions/${c.mission_id}`}
              className="flex items-center gap-4 px-6 py-3 hover:bg-zinc-50 transition-colors group"
              data-testid={`conversation-${c.mission_id}`}
            >
              <div className="w-9 h-9 bg-[#0A0A0B] text-white flex items-center justify-center display text-base shrink-0">
                {(c.with_name || "?")[0].toUpperCase()}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-baseline gap-2">
                  <span className="font-bold text-sm truncate">{c.with_name}</span>
                  <span className="mono text-[10px] uppercase tracking-widest text-zinc-400 truncate">{c.mission_title}</span>
                </div>
                <div className="text-xs text-zinc-600 truncate">
                  <span className="text-zinc-400">{c.last_sender_name} :</span> {c.last_message}
                </div>
              </div>
              <div className="text-right shrink-0">
                <div className="mono text-[10px] text-zinc-400">{frDate(c.last_at)}</div>
                <ArrowRight className="w-4 h-4 text-zinc-300 group-hover:text-[#FF4D00] ml-auto mt-1" />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
